export default {
    findAcordoById : {
        url: 'acordos/{acordo_id}',
        method: 'get',
    }
}